import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'support_pack_hub';
export const route = 'support_pack_hub/[bookingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/SupportPackPage').then(({
  SupportPackPageHub
}) => ({
  default: SupportPackPageHub
}))));